import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, FormControl } from '@angular/forms';
import { FormField } from '@fry/lib/forms';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-form-field',
    styleUrls: ['./form-field.component.scss'],
    templateUrl: './form-field.component.html',
    standalone: false
})
export class FormFieldComponent implements OnInit {
  @Input() field: FormField;
  @Input() formGroup: UntypedFormGroup;

  public searchCtrl: FormControl = new FormControl();
  public filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  private unsubscribe: Subject<void> = new Subject();

  _categories$ = new BehaviorSubject<any[]>([]);
  categories$ = this._categories$.asObservable().pipe(
    distinctUntilChanged()
  );

  constructor() {
  }

  ngOnInit() {
    const options = this.field.options || {};

    if (options.categories) {
      if (!options.required && this.field.widget!.type === "select") {
        const categories = [{ name: 'None', _id: null }, ...options.categories];
        this._categories$.next(categories);
      } else {
        this._categories$.next(options.categories);
      }

      // Subscribe to value changes on search control
      if (["select", "multiSelect"].includes(this.field.widget!.type)) {
        this.filterOptions();
        this.searchCtrl.valueChanges
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(() => this.filterOptions());
      }
    }
  }

  protected filterOptions() {
    if (!this._categories$.value) {
      return;
    }
    let search = this.searchCtrl.value;
    if (!search) {
      this.filteredOptions$.next(this._categories$.value.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredOptions$.next(
      this._categories$.value.filter(option => option.name.toLowerCase().indexOf(search) > -1 && option.value !== '')
    );
  }
}
